module.exports = __webpack_public_path__ + "static/media/Profile1.05741b89.jpg";